// extracted by mini-css-extract-plugin
var _1 = "DeletedView-module__animatedBackground--kdxWG";
var _2 = "DeletedView-module__container--xR7UJ";
var _3 = "DeletedView-module__emptyWrapper--tJew8";
export { _1 as "animatedBackground", _2 as "container", _3 as "emptyWrapper" }
